export const getToken = () => {
  try {
    const tokenString: string = Object.keys(localStorage).find((key) =>
      key.includes("oidc.user")
    ) as string;
    if (!tokenString) {
      console.warn("No OIDC token found in localStorage");
      return null;
    }
    const rawToken = localStorage.getItem(tokenString);
    if (!rawToken) {
      console.warn("Token key exists but value is null");
      return null;
    }

    const tokenObj = JSON.parse(rawToken);
    if (!tokenObj?.access_token) {
      console.warn("Token object does not contain access_token");
      return null;
    }
    // const tokenObj = JSON.parse(localStorage.getItem(tokenString) ?? "{}");
    // const { access_token } = tokenObj;
    return tokenObj.access_token;
  } catch (error) {
    console.error("Error retrieving token:", error);
    return null;
  }
};
